import { ThemeFactory, Theme } from "react-ui";
import { LIGHT_THEME_5_0 as LIGHT_THEME } from "@skbkontur/react-ui";
import { KonturColors } from "@skbkontur/colors";

export const reactUIDiadocTheme: Theme = ThemeFactory.create(
    {
        bgActive: "#13B49B",
        blinkColor: "rgba(198, 241, 235, 1)",
        borderColorFocus: "#00957f",
        borderColorFocusLight: "#66ccbc",
        btnFontSizeMedium: "16px",
        btnMenuArrowColor: "#A6A6A6",
        btnPrimaryActiveBg: "#007261",
        btnPrimaryActiveBorderColor: "#007261",
        btnPrimaryActiveShadow: "0 -1px 0 0 #33534e, 0 0 0 1px #4c746f, inset 0 1px 2px 0 rgba(0, 0, 0, 0.1)",
        btnPrimaryBorderColor: "#009982",
        btnPrimaryBg: "#00806D",
        btnPrimaryBgEnd: "#00806D",
        btnPrimaryHoverBorderColor: "#00A38B",
        btnPrimaryBgStart: "#00A58D",
        btnPrimaryHoverBgEnd: "#00806D",
        btnPrimaryHoverBgStart: "#00A38B",
        btnSuccessActiveBg: "#007261",
        btnSuccessActiveShadow: "0 -1px 0 0 #33534e, 0 0 0 1px #4c746f, inset 0 1px 2px 0 rgba(0, 0, 0, 0.1)",
        btnSuccessBg: "#009982",
        btnSuccessBgEnd: "#00806D",
        btnSuccessBgStart: "#00A58D",
        btnSuccessHoverBg: "#00A38B",
        btnSuccessHoverBgEnd: "#00806D",
        btnSuccessHoverBgStart: "#00A38B",
        linkActiveColor: KonturColors.greenMint70,
        linkColor: KonturColors.greenMint90,
        btnLinkColor: KonturColors.greenMint90,
        linkDisabledColor: KonturColors.grayscaleDisabledText,
        btnLinkDisabledColor: KonturColors.grayscaleSecondaryText,
        linkHoverColor: "#7d7d7d",
        btnLinkHoverColor: KonturColors.greenMint70,
        linkHoverTextDecoration: "none",
        toggleBgChecked: "#00957f",
        tabColorHoverPrimary: "#7d7d7d",
    },
    LIGHT_THEME
);
